/** IANA time zone from the runtime (typically `Intl` in the browser). */
export function getBrowserIanaTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
